/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { StaticQuery, graphql } from "gatsby"
import Navigation from "./Navigation/Navigation"
// import drupalOauth from "../components/drupal-oauth/drupalOauth"
// import withDrupalOauthProvider from "../components/drupal-oauth/withDrupalOauthProvider"
import styles from "./layout.module.css"

// Initialize a new drupalOauth client which we can use to seed the context
// provider.
// const drupalOauthClient = new drupalOauth({
//   drupal_root: "https://dev-hosd8site.pantheonsite.io",
//   client_id: "e3d612dd-fbb7-4c46-930e-eae6626fc071",
//   client_secret: "1234",
// })

const Layout = props => {
  const { children } = props

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: "description", content: "Sample" },
              { name: "keywords", content: "sample, something" },
              {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1",
              },
            ]}
          >
            <html lang="en" />
          </Helmet>
          <div className={styles.container}>
            <Navigation siteTitle={data.site.siteMetadata.title} />
            <div component="main">{children}</div>
          </div>
        </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
